/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GetTasksByModuleVersionParams = {
  user_id?: string | null;
  course_id?: string | null;
  include?: string | null;
  as_admin?: unknown;
  page?: number;
  pageSize?: number;
  sort?: string;
  filter?: string;
};
